import React, { useState } from 'react';
import { PaymentInputsWrapper, usePaymentInputs } from 'react-payment-inputs';
import { PaymentMethodCardInput } from './payment-method-card-input';
import { PaymentMethodLineInput } from './payment-method-line-input';
import { Styled } from './styled'

export const PaymentMethodInput = (props) => {
  const { onSubmit, isCardInput } = props;
  const [cardNumber, setCardNumber] = useState();
  const [expiryDate, setExpiryDate] = useState();
  const [cvc, setCvc] = useState();
  const {
    meta,
    getCardNumberProps,
    getExpiryDateProps,
    getCVCProps,
    getCardImageProps,
    wrapperProps
  } = usePaymentInputs();
  const isValid = !meta.error && (meta.isTouched || meta.focused)
  const Input = isCardInput
    ? PaymentMethodCardInput
    : PaymentMethodLineInput;
  return (
    <Styled.Container isCardInput={isCardInput}>
      <PaymentInputsWrapper {...wrapperProps}>
        <Input
          getCardNumberProps={getCardNumberProps}
          getExpiryDateProps={getExpiryDateProps}
          getCVCProps={getCVCProps}
          getCardImageProps={getCardImageProps}
          // eslint-disable-next-line react/jsx-no-bind
          onCardNumberChange={e => setCardNumber(e.target.value)}
          // eslint-disable-next-line react/jsx-no-bind
          onExpiryChange={e => setExpiryDate(e.target.value)}
          // eslint-disable-next-line react/jsx-no-bind
          onCvcChange={e => setCvc(e.target.value)}
          // eslint-disable-next-line react/jsx-no-bind
          onSubmit={() => onSubmit({ cardNumber, expiryDate, cvc })}
          isValid={isValid}
        />
      </PaymentInputsWrapper>
    </Styled.Container>
  );
};
